import BaseModel from '../core/BaseModel'
import LoyaltyLevelModel from '@/models/LoyaltyLevelModel'
import UserModel from '@/models/UserModel'
export default class UserAdminModel extends BaseModel {

    constructor() {
        super({
                name: "user_admin",
                tableName: 'users',
                label: "User Management",
                display_key: 'fullname'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },

                avatar: {
                    name: "avatar",
                    label: "Avatar",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    //display: false,
                },
                fullname: {
                    name: 'fullname',
                    type: "String",
                    label: 'Fullname',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                email: {
                    name: 'email',
                    type: "String",
                    label: 'Email',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                phone: {
                    name: 'phone',
                    type: "String",
                    label: 'Phone number',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                loyalty_level_id: {
                    name:'loyalty_level_id',
                    label:'Loyalty Level',
                    type: "Selection",
                    custom: 'SelectionText',
                    models: new LoyaltyLevelModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class:"small-col txt-left",
                    computed: (data) => {
                        data.loyalty_level_id = '';
                    },
                },
                point_wallet: {
                    name: 'point_wallet',
                    type: "String",
                    label: 'Points',
                    width: 15,
                   // filter: {type: 'input', match: 'contains'},
                    class:"small-col-midle txt-left",
                },

                sale_person_id_fil: {
                    name:'sale_person_id_fil',
                    label:'Saleperson',
                    type: "Selection",
                    custom: 'SelectionText',
                    models: new UserModel(),
                    filter: {type: 'input', match: 'contains'},
                    // filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class:" txt-left",
                    computed: (data) => {   
                        data.sale_person_id_fil = '';
                    },
                    width: 8,
                },

                source: {
                    name: "source",
                    label: "Source",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'WEB', label: 'Website', style: 'color:  #000000;'},
                        {value: 'IOS', label: 'Ios',style: 'color:  #000000;'},
                        {value: 'ANDROID', label: 'Android',style: 'color:  #000000;'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center txt-xs-col txt-left",
                },
                total_order_key: {
                    name: 'total_order_key',
                    type: "String",
                    label: 'Rent/ Buy/ Sell',
                    custom: 'TOTAL_ORDER',
                    width: 15,
                    //filter: {type: 'input', match: 'contains'},
                    class:"small-col-midle txt-left",
                },
                status_key: {
                    name: "status_key",
                    label: "Status",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 1, label: 'Active', style: 'color:  #000000;'},
                        {value: 2, label: 'Banned',style: 'color:  #000000;'},
                        {value: 3, label: 'Deleted',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center txt-xs-col txt-left",
                },
                updated_at : {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    class:"small-col-midle txt-left",
                   // filter: { type: 'DateRange', match: 'contains'}
                },

            })
    }

}